import { Component, OnInit } from '@angular/core';
import { DashboardEmployeeService } from './dashboard-employee.service';
import { Notification } from '../employee.interface';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RequestUnlockDialogComponent } from './request-unlock-dialog/request-unlock-dialog.component';
import { SessionStorage } from 'ngx-webstorage';
import { NotificationService } from '../../common/notification/notification.service';
@Component({
  selector: 'app-dashboard-employee',
  templateUrl: './dashboard-employee.component.html',
  styleUrls: ['./dashboard-employee.component.css']
})
export class DashboardEmployeeComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;
  public projectCount: any = 0;
  public rejectedTimesheetCount: any = 0;
  public notification: Notification[] = [];
  public unapprovedTimesheet: any = 0;
  public currentDate: any;
  public cuurentYear: any;
  public currentMonth: any;
  public monthNames: any;
  public currentMonthIndex: any;
  public islocked = false;
  public unlockrequesent: boolean;
  public lockedLength: any;
  public totalHrs: any = 0;
  public pageNumber = 1;
  public totalElements: number;
  public isAdherence = false;
  public isCompliance = false;
  public timesheetStatus: any;
  public hasRm: any;
  public pendingList = [];

  constructor(
    private notificationService: NotificationService,
    private dashboardEmployeeService: DashboardEmployeeService,
    private router: Router,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    const currentDAY = new Date();
    this.monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    this.currentDate = new Date().getDate();
    this.currentMonth = this.monthNames[currentDAY.getMonth()];
    this.cuurentYear = currentDAY.getFullYear();
    this.getEmployeeDetailsDashboard();
    this.getNotificationList();
    this.getEmployeeStatus();
    this.getPendingTimesheetDetail(false);
  }

  /**function get employee detail for dashboard */
  getEmployeeDetailsDashboard() {
    this.dashboardEmployeeService.getEmployeesDetails().subscribe((data) => {
      this.projectCount = data.payload.projectcount ? data.payload.projectcount : 0;
      this.unapprovedTimesheet = data.payload.unapprovedTimesheet ? data.payload.unapprovedTimesheet : 0;
      this.totalHrs = data.payload.currfilledHrs ? data.payload.currfilledHrs : 0;
      this.rejectedTimesheetCount = data.payload.rejectedTimesheetCount ? data.payload.rejectedTimesheetCount : 0;
      const date1 = new Date();
      const date2 = new Date(data.payload.lockStatus.lockedDetails.lockedDate);
      const timeDiff = Math.abs(date2.getTime() - date1.getTime());
      this.lockedLength = Math.ceil(timeDiff / (1000 * 3600 * 24));
      this.lockedLength = (this.lockedLength == 1) ? this.lockedLength + ' day' : this.lockedLength + ' days';
      if (data.payload.lockStatus.unlockRequest.Requested) {
        this.unlockrequesent = true;
      }
      if (this.config.businessUnit === 'accenture') {
        if (data.payload.lockStatus.lockedDetails.isLocked) {
          this.islocked = true;
        }
      }
      if (this.config.businessUnit === 'ipdo' || this.config.businessUnit === 'biologics' || this.config.businessUnit === 'chinateam' || this.config.businessUnit === 'aps') {
        this.isAdherence = data.payload.lockStatus.lockedDetails.isLocked ? true : false;
        this.isCompliance = data.payload.lockStatus.lockedDetails.isNonCompliance ? true : false;
        if (this.unlockrequesent === true) {
          this.timesheetStatus = 'YOUR TIMESHEET IS LOCKED';
        } else {
          if (this.isAdherence) {
            this.timesheetStatus = 'YOUR TIMESHEET IS SET TO NON ADHERENCE';
          }
          if (this.isCompliance) {
            this.timesheetStatus = 'YOUR TIMESHEET IS SET TO NON COMPLIANCE';
          }
        }
      }
    });
  }

  /**function get notification list */
  getNotificationList() {
    this.notificationService.getNotification(this.pageNumber).subscribe((data) => {
      if (data.payload.notifications) {
        this.totalElements = data.payload.totalnotifications;
        data.payload.notifications.map(value => this.notification.push(new Notification(value)));
      }
    });
  }

  /**function to navigate to notification */
  navigationToNotification() {
    this.router.navigate(['/employee/notification']);
  }

  /**function to navigate to timesheet */
  navigationToTimesheet() {
    this.router.navigate(['/employee/timesheet-entry']);
  }

  // /**function to request for unlock */
  requestunlock() {
    if (this.config.businessUnit != 'ipdo' && this.config.businessUnit != 'chinateam' && this.config.businessUnit != 'aps') {
      if (!this.unlockrequesent) {
        if (this.dialog.openDialogs.length === 0) {
          const dialogRef = this.dialog.open(RequestUnlockDialogComponent, {
            width: 'auto'
          });
          dialogRef.afterClosed().subscribe(result => {
            this.getEmployeeDetailsDashboard();
          });
        }
      }
    }
  }

  /**function to get employee status */
  getEmployeeStatus() {
    this.dashboardEmployeeService.getLockedStatus().subscribe((data) => {
      this.hasRm = data.payload.RMCode;
    });
  }

  calendarUpdate() {
    var self = this;
    var Cal = function (divId) {
      //Store div id
      this.divId = divId;
      // Days of week, starting on Sunday
      this.DaysOfWeek = [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ];

      // Months, stating on January
      this.Months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      // Set the current month, year
      var d = new Date();

      this.currMonth = d.getMonth();
      this.currYear = d.getFullYear();
      this.currDay = d.getDate();

    };

    // Goes to next month
    Cal.prototype.nextMonth = function () {
      var d = new Date();
      var currentMonthValue = d.getMonth();
      var currentYearValue = d.getFullYear();

      // if (this.currMonth < currentMonthValue && this.currYear < currentYearValue)  {
      if (this.currMonth == 11) {
        this.currMonth = 0;
        this.currYear = this.currYear + 1;
        self.currentMonthIndex = this.currMonth;
        self.cuurentYear = this.currYear;
      }
      else {
        this.currMonth = this.currMonth + 1;
        self.currentMonthIndex = this.currMonth;
      }
      const requestMonth = {
        month: this.currMonth,
        year: this.currYear
      };
      self.dashboardEmployeeService.getCalendarPendingTimesheets(requestMonth).subscribe((data) => {
        if (data.result) {
          self.pendingList = data.result;
          this.showcurr();
        }
      },
        (err) => {
          this.showcurr();
        });
      // }
    };

    // Goes to previous month
    Cal.prototype.previousMonth = function () {
      if (this.currMonth == 0) {
        this.currMonth = 11;
        this.currYear = this.currYear - 1;
        self.currentMonthIndex = this.currMonth;
        self.cuurentYear = this.currYear;
      }
      else {
        this.currMonth = this.currMonth - 1;
        self.currentMonthIndex = this.currMonth;
      }

      const requestMonth = {
        month: this.currMonth,
        year: this.currYear
      };

      self.dashboardEmployeeService.getCalendarPendingTimesheets(requestMonth).subscribe((data) => {
        if (data.result) {
          self.pendingList = data.result;
          this.showcurr();
        }
      },
        (err) => {
          this.showcurr();
        });
    };

    // Show current month
    Cal.prototype.showcurr = function () {
      this.showMonth(this.currYear, this.currMonth);
    };

    // Show month (year, month)
    Cal.prototype.showMonth = function (y, m) {
      var d = new Date()
        // First day of the week in the selected month
        , firstDayOfMonth = new Date(y, m, 1).getDay()
        // Last day of the selected month
        , lastDateOfMonth = new Date(y, m + 1, 0).getDate()
        // Last day of the previous month
        , lastDayOfLastMonth = m == 0 ? new Date(y - 1, 11, 0).getDate() : new Date(y, m, 0).getDate();

      var html = '<table>';
      // Write selected month and year
      html += '<thead><tr>';
      html += '<td colspan="7">' + this.Months[m] + ' ' + y + '</td>';
      html += '</tr></thead>';


      // Write the header of the days of the week
      html += '<tr class="days">';
      for (var i = 0; i < this.DaysOfWeek.length; i++) {
        html += '<td class="week-name">' + this.DaysOfWeek[i] + '</td>';
      }
      html += '</tr>';

      // Write the days
      var i = 1;
      do {

        var dow = new Date(y, m, i).getDay();

        // If Sunday, start new row
        if (dow == 0) {
          html += '<tr>';
        }
        // If not Sunday but first day of the month
        // it will write the last days from the previous month
        else if (i == 1) {
          html += '<tr>';
          var k = lastDayOfLastMonth - firstDayOfMonth + 1;
          for (var j = 0; j < firstDayOfMonth; j++) {
            html += '<td class="not-current">' + k + '</td>';
            k++;
          }
        }

        // Write the current day in the loop
        var chk = new Date();
        var chkY = chk.getFullYear();
        var chkM = chk.getMonth();
        var approved = []; //2 green
        var notSubmitted = []; // unfilled red
        var rejected = []; //1 purple or blue
        var drafted = []; // "" red
        var submitted = []; // 0 yellow

        self.pendingList.forEach(element => {
          switch (element.approvalStatus.status) {
            case 0: submitted.push(element.dateDetails.day);
              break;
            case 1: rejected.push(element.dateDetails.day);
              break;
            case 2: approved.push(element.dateDetails.day);
              break;
            case "": drafted.push(element.dateDetails.day);
              break;
            case "unfilled": notSubmitted.push(element.dateDetails.day);
              break;
          }
        });

        if (chkY == this.currYear && chkM == this.currMonth && i == this.currDay) {
          html += '<td class="today">' + i + '</td>';
        } else {
          var className = rejected.indexOf(i) >= 0 ? 'blue' : '';
          className += submitted.indexOf(i) >= 0 ? 'yellow' : '';
          className += approved.indexOf(i) >= 0 ? 'green' : '';
          className += drafted.indexOf(i) >= 0 ? 'red' : '';
          className += notSubmitted.indexOf(i) >= 0 ? 'red' : '';
          html += '<td class="normal ' + className + '">' + i + '</td>';
        }

        // If Saturday, closes the row
        if (dow == 6) {
          html += '</tr>';
        }
        // If not Saturday, but last day of the selected month
        // it will write the next few days from the next month
        else if (i == lastDateOfMonth) {
          var k = 1;
          for (dow; dow < 6; dow++) {
            html += '<td class="not-current">' + k + '</td>';
            k++;
          }
        }

        i++;
      } while (i <= lastDateOfMonth);

      // Closes table
      html += '</table>';

      // Write HTML to the div
      document.getElementById(this.divId).innerHTML = html;
    };

    // Start calendar
    var c = new Cal("divCal");

    c.showcurr();

    // Bind next and previous button clicks
    getId('btnNext').onclick = function () {
      c.nextMonth();
    };
    getId('btnPrev').onclick = function () {
      c.previousMonth();
    };

    // Get element by id
    function getId(id) {
      return document.getElementById(id);
    }
  }

  updateClassFunction(data) {

  }

  getPendingTimesheetDetail(data) {
    if (!data) {
      this.monthNames.forEach((element, index) => {
        if (this.currentMonth === element) {
          this.currentMonthIndex = index;
        }
      });
    }
    const requestMonth = {
      month: this.currentMonthIndex,
      year: this.cuurentYear
    };
    this.dashboardEmployeeService.getCalendarPendingTimesheets(requestMonth).subscribe((data) => {
      if (data.result) {
        this.pendingList = data.result;
        this.calendarUpdate();
      }
    },
      (err) => {
        this.calendarUpdate();
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard-employee/dashboard-employee.component.ts